<template>
  <div class="hcl-form-element-widget" v-if="!definitionField.field.hidden">
    <div class="form-group">
      <label :for="fieldName">
        {{ definitionField.field.title }}
        <hcl-form-label-info v-if="labelHasInfo" :labelInfo="props.definitionField.field.info"></hcl-form-label-info>
      </label>
      <div class="input-group">
        <div v-if="
          props.definitionField.field.widget.type === 'search-field-group' ||
          props.definitionField.field.widget.type === 'search-field-single'
        " :id="'container' + props.definitionField.field.widget.id" class="w-100 c-select-dropdown dropdown"
          :widget="props.definitionField.field.widget.widget" v-bind="generateDataAttributes">
          <div class="c-select-dropdown__input-wrapper input-group">
            <div :id="'selected' + props.definitionField.field.widget.id" type="text"
              class="c-select-dropdown__input form-control" readonly="true">
              <span style="color: #777">
                -- {{ props.definitionField.field.widget.placeholder }} --
              </span>
            </div>

            <input ref="fieldRef" :id="props.definitionField.field.widget.id" type="hidden" :name="fieldName"
              v-model="props.dataField.value" />

            <div class="input-group-append">
              <div :id="'toggle' + props.definitionField.field.widget.id" class="c-select-dropdown__icon btn btn-link">
                <i :id="'down' + props.definitionField.field.widget.id" class="icon-pull-up eii--fa6-solid--sort-down"></i>
                <i :id="'up' + props.definitionField.field.widget.id" class="icon-pull-up eii--fa6-solid--sort-up" style="display: none"></i>
              </div>
              <button :id="'search' + props.definitionField.field.widget.id"
                class="c-select-dropdown__btn btn btn-outline-default" type="button" :title="props.definitionField.field.widget.title_search_button">
                <i class="eii--fa6-solid--magnifying-glass"></i>
              </button>
            </div>
          </div>
          <ul :id="'dropdown' + props.definitionField.field.widget.id"
            class="c-select-dropdown-menu dropdown-menu full-width" style="display: none">
            <li class="c-select-dropdown-menu__wrapper">
              <span class="c-select-dropdown-menu__search">
                <input :id="'input' + props.definitionField.field.widget.id" type="text" class="form-control"
                  tabindex="-1" :placeholder="props.definitionField.field.widget.placeholder_text_input" />
              </span>
              <span class="c-select-dropdown-menu__options" aria-selected="false" aria-disabled="false">
                <label :id="'selectAll' + props.definitionField.field.widget.id" class="c-select-dropdown-menu__item">
                  <input :id="'checkAll' + props.definitionField.field.widget.id" type="checkbox"
                    class="hcl-input-checkbox" />
                    {{ props.definitionField.field.widget.checkbox_select_all }}
                </label>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/*
 * This Vue Component implements templates and code for various legacy widgets,
 * since we can not reimplement all or many of the in Vue right away.
 *
 * The template code for widget types 'search-field-single' and 'search-field-group'
 * is taken from the views 'views/default/controller/search-field/field-single.php' and
 * 'views/default/controller/search-field/field-group.php' respectively.
 *
 */
// @improvement: verify that we need this component at all...
import { onMounted } from 'vue'

import { useElement } from '@/components/FormElement/element'

import HclFormLabelInfo from '@/components/FormLabelInfo/FormLabelInfo.vue'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined
})

const { 
  fieldRef,
  fieldName,
  generateDataAttributes,
  labelHasInfo
} = useElement(props)

onMounted(() => {
  if (props.definitionField.field.focus) fieldRef.value.focus()
})
</script>

<style scoped>
.icon-pull-up {
  margin-top: -0.375rem;
}
</style>
